@if (isOpen()) {
<div
  class="fixed inset-0 z-30 bg-black/40 lg:hidden"
  (click)="close()"
  aria-hidden="true"></div>
}

<aside
  class="bg-sidebar fixed inset-y-0 left-0 z-40 flex h-dvh w-72 -translate-x-full flex-col transition-transform duration-300 ease-out lg:sticky lg:top-0 lg:z-auto lg:h-dvh lg:translate-x-0"
  [class.translate-x-0]="isOpen()">
  <div class="flex items-center justify-between gap-3 border-b border-white/10 px-6 py-6">
    <div class="flex items-center gap-2.5">
      <app-icon
        name="star"
        [size]="20"
        class="text-turquoise" />
      <span class="font-display text-lg font-bold text-white">SuperHeroes</span>
    </div>
    <button
      type="button"
      class="-mr-2 p-2 text-white/60 hover:text-white lg:hidden"
      (click)="close()">
      <app-icon
        name="close"
        [size]="20" />
      <span class="sr-only">Cerrar menú</span>
    </button>
  </div>

  <nav
    class="flex-1 space-y-0.5 overflow-y-auto px-3 py-5"
    aria-label="Navegación principal">
    @for (item of navItems; track item.route) {
    <a
      [routerLink]="item.route"
      routerLinkActive
      #rla="routerLinkActive"
      (click)="close()"
      [class]="rla.isActive ? 'bg-accent text-white shadow-elevated' : 'text-sidebar-muted hover:bg-white/[0.06] hover:text-white'"
      class="flex items-center gap-3 rounded-full px-4 py-2.5 text-sm font-medium transition-colors">
      <app-icon
        [name]="item.icon"
        [size]="18" />
      {{ item.label }}
    </a>
    }
  </nav>

  <div class="border-t border-white/10 px-6 py-5">
    <p class="text-sidebar-muted text-xs">© {{ currentYear }} SuperHeroes</p>
  </div>
</aside>
